import { IThinProfile } from './ThinProfile';

export interface IUser {
  id: string;
  type: 'users';
  email: string;
  package: string;
  first_name: string;
  last_name: string;
  terms_accepted_at: string;
  role: string;
  event_managers_count: number;
  profiles?: Array<IThinProfile>;
  // Computed properties (added after enrichment)
  fullName?: string;
  isEventManager?: boolean;
  firstProfile?: IThinProfile;
}

export function enrichUser(user: IUser): IUser {
  const fullName =
    user.first_name && user.last_name ? `${user.first_name} ${user.last_name}` : user.email?.replace(/@.*/, '') || '';

  return {
    ...user,
    fullName,
    isEventManager: (user.event_managers_count || 0) > 0,
    firstProfile: user.profiles?.[0],
  };
}
